import {
  DialogTitle
} from "./chunk-QD5XPARQ.mjs";
import {
  DialogTrigger
} from "./chunk-DMTWEQYW.mjs";
import {
  DialogActions
} from "./chunk-56EADXIR.mjs";
import {
  DialogClose
} from "./chunk-ECDRZFTD.mjs";
import {
  DialogContent
} from "./chunk-KGK3AOF2.mjs";
import {
  DialogDescription
} from "./chunk-CY53PB3Z.mjs";
import {
  DialogSet
} from "./chunk-XQEYOHRW.mjs";

// src/dialog/src/dialog.tsx
import { Root } from "@radix-ui/react-dialog";
import { jsx } from "react/jsx-runtime";
var Dialog = (props) => /* @__PURE__ */ jsx(Root, { ...props });
Dialog.Actions = DialogActions;
Dialog.Close = DialogClose;
Dialog.Content = DialogContent;
Dialog.Set = DialogSet;
Dialog.Title = DialogTitle;
Dialog.Trigger = DialogTrigger;
Dialog.Description = DialogDescription;
Dialog.displayName = "Dialog";

export {
  Dialog
};
